import type { NotificationNode } from '@/components/Dashboard/NotificationCard/types'

import { groupByTimeBucket } from './groupByTimeBucket'

export type NotificationRow =
  | { key: string; type: 'bucket'; bucketKey: string }
  | { key: string; type: 'card'; notification: NotificationNode }

export const notificationRows = (notifications: NotificationNode[]): NotificationRow[] =>
  groupByTimeBucket(notifications).flatMap((bucket) => [
    { key: `bucket-${bucket.key}`, type: 'bucket' as const, bucketKey: bucket.key },
    ...bucket.items.map((notification) => ({ key: notification.id, type: 'card' as const, notification })),
  ])
